import $ from 'jquery';
window.$ = window.jQuery = $;

import 'select2';
import 'jquery-validation';
import 'dropify';
import 'datatables.net';
import 'datatables.net-responsive';
import 'jquery-datatables-checkboxes';
import 'magnific-popup';


import 'select2/dist/css/select2.css';
import 'dropify/dist/css/dropify.css';
// import 'datatables.net-dt/css/jquery.dataTables.css';
// import 'datatables.net-dt/css/jquery.dataTables.css';
import 'datatables.net-responsive-dt/css/responsive.dataTables.css';
import 'magnific-popup/dist/magnific-popup.css';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import 'materialize-css/dist/css/materialize.css';
import 'jquery-datatables-checkboxes/css/dataTables.checkboxes.css';

import PerfectScrollbar from 'perfect-scrollbar';
window.PerfectScrollbar = PerfectScrollbar;

import 'materialize-css/dist/js/materialize.js';
// import 'bootstrap';

import './plugins';
import './search';
import './custom/custom-script';


$(document).ready(function () {

    if ($('.gallery-item').length) {
        $('.gallery-item').magnificPopup({
            type: 'image',
            gallery: { enabled: true }
        });
    }

    if ($('#example-table').length) {
        $('#example-table').DataTable({
            responsive: true
        });
    }

    if ($('.dropdown-trigger').length) {
        $('.dropdown-trigger').dropdown();
    }

    if ($('.sidenav').length) {
        $('.sidenav').sidenav();
    }

    if ($('.select2').length) {
        $('.select2').select2();
    }

    if ($('.validate-form').length) {
        $('.validate-form').validate();
    }

    if ($('.dropify').length) {
        $('.dropify').dropify();
    }

    $('.scroll-container').each(function () {
        new PerfectScrollbar(this);
    });


    $('button.auto-trigger').off('click'); 
});